module.exports = __webpack_public_path__ + "static/media/Team.ef7e8de6.webp";